import { Attributes } from "../../shared/types/attributes.type";

export class BatchInventoryResultError {
  private constructor(
    public readonly ticker: string,
    public readonly relatedTickersList: string[],
    public readonly valueType: string,
    public readonly errorCode: string,
    public readonly errorMessage: string
  ) {}

  static of(props: Attributes<BatchInventoryResultError>): BatchInventoryResultError {
    return new BatchInventoryResultError(
      props.ticker,
      props.relatedTickersList,
      props.valueType,
      props.errorCode,
      props.errorMessage
    );
  }
}

export class BatchInventoryResultEntity {
  private constructor(
    public readonly createdInventories: number = 0,
    public readonly deletedInventories: number = 0,
    public readonly updatedInventories: number = 0,
    public readonly unchangedInventories: number = 0,
    public readonly createdVariables: string[] = [],
    public readonly errors: BatchInventoryResultError[] = []
  ) {}

  static of(
    props: Partial<Attributes<BatchInventoryResultEntity>> &
      Pick<Attributes<BatchInventoryResultEntity>, "createdVariables" | "errors">
  ): BatchInventoryResultEntity {
    return new BatchInventoryResultEntity(
      props.createdInventories ?? 0,
      props.deletedInventories ?? 0,
      props.updatedInventories ?? 0,
      props.unchangedInventories ?? 0,
      props.createdVariables,
      props.errors
    );
  }
}
